<template>
  <div v-if="instagram">
    <div class="panel__top d-flex align-items-center justify-content-between">
      <div>@{{ instagram.handle }}</div>
      <div>{{ instagram.followers_count }} followers</div>
    </div>
    <div class="instagram--private" v-if="instagram.private">
      <span>Private Account</span>
      <span>No Photos Available</span>
    </div>
    <div class="instagram--private" v-if="!instagram.active">
      <span>Instagram Profile Not Available.</span>
    </div>
    <div class="grid" v-else-if='instagram.instagram_posts'>
      <div class="grid-col" v-for='post in instagram.instagram_posts' v-bind:key='post.id'>
        <div class="image-square">
          <img v-bind:src="proxiedImageUrl(post.display_url)" v-bind:alt='post.alt' />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'

export default {
  emits: ['load'],
  data() {
    return {
      instagram: null
    }
  },
  methods: {
    proxiedImageUrl(imageUrl) {
      return `${process.env.VUE_APP_API_BASE_URL}/instagram_proxy?url=${btoa(imageUrl)}`
    }
  },
  mounted() {
    const customerId = this.$route.params.customer_id;

    api.getCustomerInstagram(customerId).then(instagram => {
      this.instagram = instagram;
      this.$emit('load', instagram.followersCount)
    }).catch(err => {
      console.warn('Instagram failed: ', err);
    })
  }
}
</script>

<style scoped>
.instagram--private {
  color: #C4C4C4;
  height: 340px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
